<template>
    <div class="grid min-h-screen grid-cols-1 bg-gray-50 xl:grid-cols-2">
        <div class="relative col-span-1" style="background-color: #eaf4f6;">
            <!-- <img :src="asset('img/onboarding-bg.jpg')" class="absolute inset-0 object-cover w-full h-full" /> -->

            <div class="container flex flex-col h-full py-5">
                <div><app-logo></app-logo></div>
                <div class="flex flex-col items-center justify-center flex-1">
                    <div class="w-full max-w-5xl">
                        <slot name="heading">
                            <h1 class="mb-6 text-4xl font-bold md:text-6xl">Getting Started</h1>
                            <p class="text-lg">Please fill out the form to create your new user account.</p>
                        </slot>
                    </div>
                </div>
            </div>
        </div>

        <div class="relative col-span-1">
            <div class="container flex flex-col items-center justify-center h-full">
                <div class="w-full max-w-md py-10">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLogo from '@Components/ApplicationLogo'

export default {
    components: {
        AppLogo
    },
    props: {

    }
}
</script>

<style>

</style>
